import { AuthenticatorFormFields } from './AuthenticatorFormFields';
import { AuthenticatorComponent } from './AuthenticatorComponent';
import {
    ConfirmSignInInput,
    ConfirmSignInOutput,
    confirmSignIn,
    signIn,
} from 'aws-amplify/auth';
import { AuthenticatorProps } from '@aws-amplify/ui-react';
import { PhoneNumberConfirmationDialog } from './PhoneNumberConfirmationDialog';
import { normalizeJapaneseMobilePhoneNumber } from './phoneNumberValidation';
import { openAsyncDialog } from '../dialog/AsyncDialog';

export const authenticatorSettings = {
    services: {
        // サインイン時の処理
        async handleSignIn({ username, password, options }) {
            try {
                const signInResult = await signIn({
                    username,
                    password,
                    options: {
                        ...options,
                        authFlowType: 'USER_SRP_AUTH',
                    },
                });
                return signInResult;
            } catch (error) {
                console.log({ error });
                throw error;
            }
        },

        // @ts-ignore
        async handleForceChangePassword(input: ConfirmSignInInput) {
            const phoneNumber = input.options?.userAttributes?.phone_number;

            if (!phoneNumber) {
                throw new Error('電話番号を入力してください。');
            }

            const normalizedPhoneNumber =
                normalizeJapaneseMobilePhoneNumber(phoneNumber);

            if (!normalizedPhoneNumber) {
                throw new Error(
                    'SMSを受信可能な携帯電話番号を入力してください.'
                );
            }

            const { ok } = await openAsyncDialog(
                PhoneNumberConfirmationDialog,
                { phoneNumber: normalizedPhoneNumber }
            );

            if (!ok) {
                throw new Error(
                    '電話番号を確認し、必要であれば修正してください。'
                );
            }

            return confirmSignIn({
                ...input,
                options: {
                    ...input.options,
                    userAttributes: {
                        ...input.options?.userAttributes,
                        phone_number: normalizedPhoneNumber,
                    },
                },
            });
        },

        // mfa認証時の処理
        async handleConfirmSignIn({
            challengeResponse,
        }): Promise<ConfirmSignInOutput> {
            const signInResult = await confirmSignIn({
                challengeResponse,
            });
            if (!signInResult.isSignedIn) {
                throw new Error(
                    '認証コードが間違っています。もう一度正確な認証コードを入力してください。認証コードを再送信しました。お手数ですが、受信ボックスを確認してください。'
                );
            }
            return signInResult;
        },
    },
    formFields: AuthenticatorFormFields,
    components: AuthenticatorComponent,
    hideSignUp: true,
} as const satisfies AuthenticatorProps;
